import { errorHandler } from 'utils'
import { PackCreation } from '../../model/pack'
import Api from './Api'

class Pack extends Api {
  readonly urls = {
    pharmacyPacks: '/Pack/GetPharmacyPacks',
    packDetail: '/Pack/Detail/',
    saveAll: '/Pack/SaveAll',
    removePack: '/Pack/Remove?packID=',
    allPacks: '/Pack/AllPacks',
  }

  getPharmacyPacks = async (): Promise<any> => {
    const result = await this.postData(this.urls.pharmacyPacks)
    return result.data
  }

  getPackDetail = async (id: string | number): Promise<any> => {
    const result = await this.postData(`${this.urls.packDetail}${id}`)
    return result.data
  }

  savePack = async (data: PackCreation): Promise<any> => {
    const result = await this.postJsonData(this.urls.saveAll, data)
    return result.data
  }

  removePack = async (id: string | number): Promise<any> => {
    const result = await this.postData(`${this.urls.removePack}${id}`)
    return result.data
  }

  allPacks = async (skip: number, top: number = 10): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.allPacks}?$top=${top}&$skip=${
          skip * top
        }&$orderby=id desc`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default Pack
